<template>
    <div>
        <div class="top">
            <img src="../assets/verify/img1.png" />
            <div class="app">
                <img src="../assets/verify/app.png" alt="" />
                <div>手机扫码下载</div>
                <div>奇瑞汽车APP</div>
            </div>
            <div class="weixin">
                <img src="../assets/verify/weixin.jpg" alt="" />
                <div>微信扫一扫</div>
                <div>进入车主俱乐部小程序</div>
            </div>
        </div>
      <img src="../assets/verify/img2.png" />
      <img src="../assets/verify/img3.png" />
      <img src="../assets/verify/img4.png" />
      <img src="../assets/verify/img5.png" />
      <div class="bottom">
        <div class="line1">
            <span @click="linkTo('aboutChery')">关于奇瑞</span>
            <span @click="linkTo('contactUs')">联系我们</span>
            <span @click="linkTo('user')">用户协议</span>
            <span @click="linkTo('secret')">隐私协议</span>
        </div>
        <div class="line2">版权所有© 奇瑞汽车股份有限公司 皖ICP备05009427号-1</div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'verify',
    data() {
      return {
      }
    },
    props: {},
    watch: {},
    mounted() {},
    /* eslint-disable */
    methods: {
      linkTo(type) {
        let url = ''
        switch(type) {
            case 'aboutChery':
                url = 'https://www.chery.cn'
                break
            case 'contactUs':
                url = 'https://www.chery.cn/others/contact-us'
                break
            case 'user':
                url = 'https://img.chery.cn/chery-app-fe/chery-consumer-fe/agreement/user.html'
                break
            case 'secret':
                url = 'https://img.chery.cn/chery-app-fe/chery-consumer-fe/agreement/secret.html'
                break
        }
        location.href = url
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  img {
    width: 100%;
    display: block;
  }
  .top {
    position: relative;
    .app {
        position: absolute;
        width: 125px;
        left: 13%;
        bottom: 13px;
        > div {
            width: 100%;
            color: white;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
        }
    }
    .weixin {
        position: absolute;
        width: 125px;
        left: 13%;
        bottom: 13px;
        margin-left: 137px;

        > div {
            width: 100%;
            color: white;
            font-size: 14px;
            line-height: 18px;
            text-align: center;

            &:nth-child(3) {
                font-size: 12px;
            }
        }
    }
  }
  .bottom {
    background-color: #69DBE5;
    > div {
        color: #fff;
        font-size: 12px;
        text-align: center;
        span {
            font-size: 24px;
            font-weight: 400;
            cursor: pointer;
        }
    }
    .line1 {
        padding-top: 30px;
        margin: 0 auto 15px;
        display: flex;
        width: 540px;
        justify-content: space-between;
        align-items: center;
    }
    .line2 {
        width: 420px;
        margin: 0 auto;
        padding-bottom: 20px;
        text-align-last: justify;
    }
  }
  </style>
  